<template>
  <el-dialog title="我的优惠券"
             :custom-class="'select-coupon-popover ' + popperClass"
             :show-close="false"
             width="700px"
             :visible.sync="visibleValue"
             :close-on-press-escape="false"
             :close-on-click-modal="true"
             :modal-append-to-body="true"
             :append-to-body="true"
             @closed="closedCallback">
    <div v-loading="loading"
         element-loading-text="正在计算优惠金额">
      <div class="select-coupon-list">
        <template v-for="(item,index) in list">
          <!-- <div class="select-coupon-item"
               :class="{disabled:judgeDisabled(item)}"
               @click="clickCouponItem(item)"> -->
          <div class="select-coupon-item"
               :class="{disabled:judgeDisabled(item)}"
               @click="clickCouponItem(item)">
            <div class="select-tag"
                 :class="{'is-select': selectIds.includes(item.couponId)}">
              <i class="icon el-icon-check"></i>
            </div>
            <template v-if="item.typeCode === 'DC'">
              <coupon-item-cover :price="priceDC(item.price)"
                                 before-unit=""
                                 after-unit="折">
                <template slot="description">最高抵{{item.maxAmount}}</template>
              </coupon-item-cover>
            </template>
            <template v-else-if="item.typeCode === 'FR'">
              <coupon-item-cover :price="item.priceReduce">
                <template slot="description">满{{item.maxAmount}}可用</template>
              </coupon-item-cover>
            </template>
            <template v-else>
              <coupon-item-cover :price="item.priceReduce">
                <template slot="description">下单立减</template>
              </coupon-item-cover>
            </template>

            <div class="coupon-info-box">
              <div class="coupon-name">{{ item.couponRulesName }}</div>
              <div class="coupon-time">有效期至 {{ item.endTime | toDate("YYYY-MM-DD HH:mm:ss") }}</div>
              <div class="coupon-description text-two-line">{{ item.couponRulesDescribe }}</div>
              <div class="coupon-error text-over-hide" v-if="judgeDisabled(item)">{{ judgeDisabled(item) }}</div>
            </div>
            <coupon-fixed-tag>
              <span class="tag tag-gary is-plain" v-if="!item.isOverlay">不可叠加</span>
            </coupon-fixed-tag>
            <!--          <div class="coupon-right">-->
            <!--            <el-button class="use-btn new-primary-btn"-->
            <!--                       type="primary">使用</el-button>-->
            <!--          </div>-->
          </div>
        </template>
        <div v-if="!list || !list.length"
             style="padding: 0 20px;"
        >
<!--          <el-alert-->
<!--            title="抱歉！暂无可用优惠券"-->
<!--            type="error">-->
<!--          </el-alert>-->
          <p>抱歉！暂无可用优惠券...</p>
        </div>
      </div>
    </div>
    <div class="footer-row">
      <template v-if="useCouponAfterData.discountAmount && useCouponList.length">
        <div class="discount-amount-box">
<!--          <div class="discount-amount-row">-->
<!--            <span class="label">订单金额：</span>-->
<!--            <span class="content color-price">￥{{ orderAllAmount }}</span>-->
<!--          </div>-->
<!--          <div class="discount-amount-row">-->
<!--            <span class="label">可用优惠券金额：</span>-->
<!--            <span class="content color-price">￥{{ orderAmount }}</span>-->
<!--          </div>-->
          <div class="discount-amount-row">
            <span class="label">预计优惠：</span>
            <span class="content color-price">￥{{useCouponAfterData.discountAmount}}</span>
          </div>
<!--          <div class="discount-amount-row">-->
<!--            <span class="label">优惠后金额：</span>-->
<!--            <span class="content color-price">￥{{useCouponAfterData.discountAfterAmount}}</span>-->
<!--          </div>-->
        </div>

      </template>
      <div class="flex-1"></div>
      <span style="display: inline-block;margin-right: 14px" v-if="selectValue.length">已选{{selectValue.length}}张</span>
      <el-button type="" @click="closedDialog">取消</el-button>
      <template v-if="list && list.length">
        <el-button type="primary" class="new-primary-btn" :disabled="loading"  @click="clickConfirm">确认选择</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import {mixinsDialog} from "my-element-mixins"
import CouponItemCover from "./couponItemCover"
import {isArray, isObject} from "my-tools-kit"
import CouponFixedTag from "./couponFixedTag"
import {estimatedUseCouponFee, getBaseDataCountCouponAfterFee} from "./estimated"

export default {
  name: "selectCouponList",
  components: {CouponFixedTag, CouponItemCover},
  mixins:[mixinsDialog],
  props: {
    selectType: {
      type: String,
      default: 'single',
    },
    popperClass: {
      type: String,
      default: "",
    },
    // beforeParams: { // 调用优惠券试算接口需要的前置参数（除优惠券列表外）
    //   type: Object,
    //   default: ()=>({}),
    // },
    list: { // 全部优惠券列表
      type: Array,
      default: ()=>[],
    },
    defaultSelect: { //默认选中优惠券列表
      type: Array,
      default: ()=>[],
    },
    orderAmount: { // 可使用优惠券订单金额，用来判断满减券是否可用
      type: Number,
      default: 0,
    },
    orderAllAmount: { // 订单总金额
      type: Number,
      default: 0,
    },
    isFastOpen:Boolean,
  },
  data(){
    return {
      loading:false,
      selectValue:[],//当前选中优惠券列表,点击确认返回的也是改列表
      useCouponList:[],//存放试算优惠券接口返回的有效优惠券列表,每次优惠券试算接口需同步selectValue[]
      useCouponAfterData:getBaseDataCountCouponAfterFee(), // 存放试算接口返回后计算的数据
    }
  },
  computed:{
    /**
     * 当前选中优惠券id列表
     * @returns {*[]}
     */
    selectIds(){
      return this.selectValue.map(res=>res.couponId);
    },
    /**
     * 当前选中的 不可叠加 优惠券id列表
     * @returns {*[]}
     */
    selectOverlayIds(){
      return this.selectValue.filter(res=>!res.isOverlay).map(res=>res.couponId);
    },
    preCutCount() {
      return this.selectValue.length ? this.selectValue.map(v => v.priceReduce).reduce((pre, nex) => {
        return pre + nex
      }) : []
    }
  },
  comments:{
    /**
     * 获取已选列表中 最大立减金额，依赖计算折扣券是否使用
     */
    maxCPAmount(){
      let amount = 0;
      this.selectValue.forEach(res=>{
        if(res.typeCode === "CP"){
          if(res.price > amount) amount = res.price;
        }
      });
      return amount;
    }
  },
  watch:{
    isShow(newValue){
      if(newValue){
        if(isArray(this.defaultSelect)) {
          this.selectValue = this.defaultSelect.map(id=>id);
          // this.countUseCouponFee();
        }
      }else{
        // this.selectValue = [];
      }
    },
  },
  methods:{
    /**
     * 折扣比例
     */
    priceDC(price){
      return Math.round(price * 1000)/100;
    },
    /**
     * 关闭回调
     */
    closedCallback() {
      this.selectValue = [];
      this.useCouponList = [];//存放试算优惠券接口返回的有效优惠券列表
      this.useCouponAfterData = {}; // 存放试算接口返回后计算的数据
      this.$emit('closed');
    },
    /**
     * 点击 选中/取消选中
     * @param item
     * @returns {boolean}
     */
    clickCouponItem(item = {}){
      if(this.loading) return false;
        if(!(isObject(item) && item.couponId)) return false;
      if (this.selectType === 'single') {
        if(this.judgeDisabled(item)) return false;
        this.selectValue = [item]
      } else {
        let index = this.selectValue.findIndex(res=> res.couponId === item.couponId);
        if(index >=0){
          this.selectValue.splice(index,1);
        }else{
          if(this.judgeDisabled(item)) return false;
          this.selectValue.push(item);
        }
      }
      // this.countUseCouponFee();
    },
    /**
     * 判断某张优惠券是否需要禁用
     */
    judgeDisabled(item = {}){
      if(!(isObject(item) && item.couponId)) return "优惠券信息错误";
      let useCouponList = this.useCouponList||[];//有效使用优惠券列表
      // if(item.isOverlay && this.selectOverlayIds && this.selectOverlayIds.length){
      //   return "已使用其他不可叠加券"
      // } else if (!item.isOverlay) {
      //   if(this.selectValue.length && !this.selectOverlayIds.includes(item.couponId)) return '当前优惠券不可叠加'
      // }
      if(!item.isOverlay){
        // 当优惠券本身是不可叠加券时，如果有选中其他不可叠加券
        if(this.selectOverlayIds.length && !this.selectOverlayIds.includes(item.couponId)) return "已使用其他不可叠加券"
      }
      if (item.typeCode === "FR") {
        if(!this.orderAmount && this.orderAmount !== 0) return "订单金额异常";
        if(this.orderAmount < item.maxAmount) return "订单金额 小于 满减券最低使用条件";
        if(useCouponList.length){
          if(countAfterAmount < item.price) return "优惠后金额 小于 满减券金额";
        }
      }
      // if(item.typeCode === "DC"){
      //   if(useCouponList.length){
      //
      //   }
      // }
      if (item.typeCode === "CP") {
        if(this.orderAmount < item.price) return "订单金额 小于 立减券金额";
        if(useCouponList.length){
          if(countAfterAmount < item.price) return "优惠后金额 小于 立减券金额";
        }
      }
      // debugger\
      if((this.orderAmount - this.preCutCount) < item.priceReduce && !this.selectIds.includes(item.couponId)) return "订单金额 小于 此优惠券金额叠加金额";
      // if(useCouponList.length){
      //   if(countAfterAmount < item.priceReduce) return "优惠后金额 小于 立减券金额";
      // }
      return "";
    },
    // /**
    //  * 试算优惠券减免金额
    //  */
    // countUseCouponFee(){
    //   // if(!this.selectValue.length) {
    //   //   this.useCouponList = [];
    //   //   this.useCouponAfterData = {};
    //   //   return Promise.resolve({code:200,message:"未选择优惠券，恢复原价"});
    //   // }
    //   // let data = Object.assign({},this.beforeParams,{
    //   //   bsnCouponCustomerDTO1List:this.selectValue,
    //   // });
    //   // if(!this.isFastOpen){
    //   //   if(!(isArray(data.estimatedOrderCostResp5DTOList) && data.estimatedOrderCostResp5DTOList.length)) return Promise.reject({message:"试算优惠券减免金额，前5段供应商报价数据为空"})
    //   // }

    //   // if(!(isArray(data.estimatedOrderCostRespDTOList) && data.estimatedOrderCostRespDTOList.length)) return Promise.reject({message:"试算优惠券减免金额，目的地报价数据为空"})
    //   // this.loading = true;
    //   // estimatedUseCouponFee
    //   //   .call(this,data,this.orderAmount)
    //   //   .then(res=>{
    //   //     console.log("悬着优惠券弹窗——试算优惠券减免金额：",res);
    //   //     let list = res.datas || [];
    //   //     this.useCouponList = list;
    //   //     this.selectValue = JSON.parse(JSON.stringify(list));
    //   //     if(res.useCouponAfterData) this.useCouponAfterData = res.useCouponAfterData;
    //   //     return res;
    //   //   })
    //   //   .finally(()=>{
    //   //     setTimeout(()=>{
    //   //       this.loading = false;
    //   //     },500);
    //   //   })
    // },
    /**
     * 点击确认选择
     */
    clickConfirm(){
      this.$emit("change",this.selectValue);
      this.closedDialog();
    },
  },
}
</script>

<style lang="scss">
.select-coupon-popover{
  border-radius: 10px;
  .el-dialog__header{
    padding: 40px 36px;
    //padding: 24px 16px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .el-dialog__body{
    padding: 0 0 40px;
  }
}
</style>
<style scoped lang="scss">
.select-coupon-list{
  padding: 0 16px;
  min-height: 120px;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  /* 滚动条样式 */
  &::-webkit-scrollbar {
    width: 4px; /*滚动条宽度*/
    height: 4px; /*滚动条高度*/
  }
  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    border-radius: 4px; /*滚动条的背景区域的圆角*/
  }
  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 4px; /*滚动条的圆角*/
    background-color: #eee; /*滚动条的背景颜色*/
  }
}
.select-coupon-item{
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 20px;
  min-height: 120px;
  border-radius: 10px;
  &:hover{
    background-color: #f5f5f5;
  }
  &:not(.disabled){
    cursor: pointer;
  }
  &.disabled{
    cursor: not-allowed;
    &:before{
      cursor: not-allowed;
      content: "";
      position: absolute;
      z-index: 2;
      display: block;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255,255,255,0.6);
    }
  }
  .coupon-info-box{
    flex: 1;
    overflow: hidden;
  }
  .coupon-name,
  .coupon-time{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .coupon-name{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .coupon-time{
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    margin-top: 6px;
  }
  .coupon-description{
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    margin-top: 6px;
  }
  .coupon-error{
    font-size: 12px;
    color: #ff0000;
    margin-top: 6px;
  }
  .coupon-right{
    margin-left: 24px;
  }
  .use-btn{
    width: 150px;
    height: 47px;
    border-radius: 24px;
  }
  .select-tag{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 24px;
    background-color: white;
    border-radius: 50%;
    margin-right: 24px;
    border: 1px solid #DCDCDC;
    color: transparent;
    cursor: pointer;
    &.is-select{
      background-color: #D82246;
      border-color: #D82246;
      .icon{
        color: white;
      }
    }
  }
}
.new-primary-btn{
  &:not(disabled):not(.is-disabled){
    &:not(:hover){
      background-color: #D82246;
      border: 1px solid #D82246;
    }
  }
}
.footer-row{
  margin-top: 40px;
  padding: 0 36px;
  display: flex;
  align-items: center;
  .el-button{
    width: 150px;
    height: 47px;
  }
}
.discount-amount-box{}
.discount-amount-row{
  .label{
    width: 100px;
  }
  .content{}
  .color-price{
    color: #D82246;
  }
  & + & {
    margin-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// common/selectCoupon/selectCouponList.vue